export default __webpack_public_path__ + "static/media/25120411.d71e4523.jpg";